module.exports = __webpack_public_path__ + "static/media/award4.918fdd44.png";


//////////////////
// WEBPACK FOOTER
// ./src/views/activity_139/images/award4.png
// module id = 1348
// module chunks = 0